'use client'

import Footer1 from '@/components/footers/Footer1'
import LoginRegister from '@/components/otherPages/LoginRegister'
import React, { useEffect } from 'react'
import { signOut, useSession } from 'next-auth/react'

export default function LoginOrRegister({ RedirectUrl = null }) {
  const { status } = useSession()

  // useEffect(() => {
  //   if (status === 'authenticated') {
  //     signOut({ redirect: false }) // 登出但不導頁
  //   }
  // }, [status])

  return (
    <>
      <main className="page-wrapper">
        <div className="mb-4 pb-4"></div>
        <LoginRegister RedirectUrl={RedirectUrl} />
      </main>

      <div className="mb-5 pb-xl-5"></div>
    </>
  )
}
